/**
 * The session id in the top bar, as on the old kiosk: its first 8 characters; a tap copies the whole
 * id (to give it to an operator, to find the recording). In a replay or with an operator, RoleLabel
 * takes its place.
 */
import { useState } from 'react';
import { report } from '../core/diagnostics';
import { useApp } from '../react/app';
import { useTranslate } from '../react/hooks';
import css from './RoleLabel.module.css';

export function SessionChip({ className = '' }: { className?: string }) {
  const { kiosk } = useApp();
  const t = useTranslate();
  const [copied, setCopied] = useState(false);
  const copy = () => {
    navigator.clipboard?.writeText(kiosk.sessionId).then(
      () => { setCopied(true); setTimeout(() => setCopied(false), 1500); },
      (e: unknown) => report('info', 'session', `cannot copy the session id: ${String(e)}`),
    );
  };
  return (
    <button className={`${css.label} ${css.session} ${className}`} onClick={copy} title={kiosk.sessionId} aria-label={t('session.copy')}>
      <span className={css.text}>{copied ? t('session.copied') : kiosk.sessionId.slice(0, 8)}</span>
    </button>
  );
}
